// /mnt/mantenimientos/frontend/src/modules/moduleIds.js

export const MODULE_IDS = {
  DASHBOARD: "dashboard",
  DASHBOARD_SUPERVISOR: "dashboard_supervisor",
  WORK_QUEUE: "work_queue",
  MANTENIMIENTOS: "mantenimientos",
  MONITORIZACION: "monitorizacion",
  EQUIPOS: "equipos",
  REMOTE_ACCESS: "remote_access",
  CREDENCIALES: "credenciales",
  BACKUPS: "backups",
  BACKUPS_NEW: "backups_new",
  AVISOS: "avisos",

  CLIENTES: "clientes",
  USUARIOS: "usuarios",
  INFORMES: "informes",
  INFRA_GLOBAL: "infra_global",
  PFSENSE_AGENTS: "pfsense_agents",
  INTEGRATIONS: "integrations",
};
